import { APPROVAL_PHASE_KEYS, TApprovalPhaseKey, TApprovalPhases } from '../types';

/** Returns the enabled phases for a given approval in canonical order. */
const getEnabledPhases = (phases: TApprovalPhases): TApprovalPhaseKey[] =>
  APPROVAL_PHASE_KEYS.filter((key) => phases[key]);

export default getEnabledPhases;
